import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.map.js";
import { flatten } from "./flatten";

//@ts-expect-error ToDo: fix this
export var deepFlatten = function deepFlatten(arr) {
  if (!arr || !Array.isArray(arr) || arr.length === 0) return [];
  return flatten(arr.map(function (x) {
    return Array.isArray(x) ? deepFlatten(x) : x;
  }));
};